import { TreeConfiguration } from 'react-complex-tree'

export function TreeLiveDescriptorContainer({
  tree,
  children,
}: {
  children: React.ReactNode
  tree: TreeConfiguration
}) {
  return (
    <div
      id={`rct-livedescription-${tree.treeId}`}
      style={{
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: '1px',
        overflow: 'hidden',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px',
      }}
    >
      {children}
    </div>
  )
}
